module.exports = __webpack_public_path__ + "static/img/aboutback.8b3b53b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutback.png
// module id = yXXI
// module chunks = 1